module.exports = __webpack_public_path__ + "img/access_map_info.b9cad198.jpg";